import { fetchAuthSession } from 'aws-amplify/auth';
import { get } from 'aws-amplify/api';
import { useQuery } from 'react-query';

export const INSURANCE_QUERY = 'INSURANCE_QUERY';

export const useProfileInsuranceQuery = (patientUserId) => {
  return useQuery({
    queryKey: [INSURANCE_QUERY, patientUserId],
    retry: false,
    queryFn: getInsurance.bind(this, patientUserId),
    placeholderData: [],
    enabled: !!patientUserId,
    select: (data) => {
      return {
        ...data,
        effectiveDate:data?.effectiveDate?.replace(/-/g, "/") ?? "",
        effectiveDateEnd:data?.effectiveDateEnd?.replace(/-/g, "/") ?? "",
      };
    },
  });
};

const getInsurance = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: 'pcmedapi',
    path: `/profile/insurance/${patientUserId}`,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
